const theme = {
  infoBlock: {
    upcommingPage: {
      container:
        'flex flex-col items-center text-center px-4 py-8 pb-[20vh] h-full justify-center',
      overline: 'text-sm uppercase tracking-widest text-gray-500 mb-2',
      title: 'text-3xl md:text-5xl font-bold text-gray-900 mb-4',
      subtitle: 'text-lg md:text-xl text-gray-700 mb-6',
    },
  },
}

export default theme
